import useReviewQueue from '@/hooks/useReviewQueue';
import FinanceXReviewQueueComponent from './FinanceXReviewQueue.component';

const FinanceXReviewQueueContainer = function (): JSX.Element {
  const queue = useReviewQueue();

  return (
    <FinanceXReviewQueueComponent
      transactions={queue.transactions}
      vendors={queue.vendors}
      categories={queue.categories}
      isLoading={queue.isLoading}
      counts={queue.counts}
      activeTab={queue.activeTab}
      onTabChange={queue.setActiveTab}
      onApprove={queue.approveOne}
      onMarkReviewed={queue.markReviewed}
      onBulkApprove={queue.bulkApprove}
      onApproveHighConfidence={queue.approveHighConfidence}
      onUpdateTransaction={queue.updateTransaction}
      onExport={queue.exportCpa}
    />
  );
};

export default FinanceXReviewQueueContainer;
